// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"9118df40","128":"fa26777b","134":"ea6ff682","168":"0bbc357d","304":"73b6e6ec","480":"2a57184f","512":"557b674c","767":"bccacd58","772":"c7c3e82f","895":"d7fee3ed","953":"bcd89dfa"}[chunkId] + ".chunk.css";
};